import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface ITisaForexRateCategoryState {
  data: {
    forexRateCategory: {[key: string]: string | number | boolean}[]
    meta: {[key: string]: number}
  }
  allData: {[key: string]: string | number | boolean}[]
  allMeta: {[key: string]: number}
  loading?: boolean
  success?: boolean
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  deleteSuccess?: boolean
}

const initialState: ITisaForexRateCategoryState = {
  data: {
    forexRateCategory: [],
    meta: {},
  },
  allData: [],
  allMeta: {},
  loading: false,
  success: false,
  activateSuccess: false,
  deactivateSuccess: false,
  deleteSuccess: false,
}

export const reducer = (
  state: ITisaForexRateCategoryState = initialState,
  action: ActionWithPayload<ITisaForexRateCategoryState>
) => {
  switch (action.type) {
    // GET
    case actionTypes.GET_TISA_FOREX_RATE_CATEGORY_START:
      return {...state, loading: true}

    case actionTypes.GET_TISA_FOREX_RATE_CATEGORY_SUCCESS: {
      const payload = action.payload as any
      const categories = payload?.data?.forexRateCategory || []
      const meta = payload?.data?.meta || {}
      return {
        ...state,
        data: {forexRateCategory: categories, meta},
        loading: false,
      }
    }

    case actionTypes.GET_TISA_FOREX_RATE_CATEGORY_FINISH:
      return {...state, loading: false}

    // GET ALL
    case actionTypes.GET_ALL_TISA_FOREX_RATE_CATEGORY_START:
      return {...state, loading: true}

    case actionTypes.GET_ALL_TISA_FOREX_RATE_CATEGORY_SUCCESS: {
      const payload = action.payload as any
      const categories = payload?.data?.forexRateCategory || []
      const allMeta = payload?.data?.meta || {}
      return {...state, allData: categories, allMeta, loading: false}
    }

    case actionTypes.GET_ALL_TISA_FOREX_RATE_CATEGORY_FINISH:
      return {...state, loading: false}

    // ADD
    case actionTypes.ADD_TISA_FOREX_RATE_CATEGORY_START:
      return {...state, loading: true}

    case actionTypes.ADD_TISA_FOREX_RATE_CATEGORY_SUCCESS:
      return {...state, success: true, loading: false}

    case actionTypes.ADD_TISA_FOREX_RATE_CATEGORY_FINISH:
      return {...state, loading: false}

    case actionTypes.ADD_TISA_FOREX_RATE_CATEGORY_RESET:
      return {...state, success: false}

    // UPDATE
    case actionTypes.UPDATE_TISA_FOREX_RATE_CATEGORY_START:
      return {...state, loading: true}

    case actionTypes.UPDATE_TISA_FOREX_RATE_CATEGORY_SUCCESS:
      return {...state, success: true, loading: false}

    case actionTypes.UPDATE_TISA_FOREX_RATE_CATEGORY_FINISH:
      return {...state, loading: false}

    case actionTypes.UPDATE_TISA_FOREX_RATE_CATEGORY_RESET:
      return {...state, success: false}

    // DELETE
    case actionTypes.DELETE_TISA_FOREX_RATE_CATEGORY_START:
      return {...state, loading: true, deleteSuccess: false}

    case actionTypes.DELETE_TISA_FOREX_RATE_CATEGORY_SUCCESS:
      return {...state, deleteSuccess: true, loading: false}

    case actionTypes.DELETE_TISA_FOREX_RATE_CATEGORY_FINISH:
      return {...state, loading: false, deleteSuccess: false}

    // SINGLE ACTIVATE
    case actionTypes.SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_REQUEST:
      return {...state, loading: true}

    case actionTypes.SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_SUCCESS:
      return {...state, activateSuccess: true, loading: false}

    case actionTypes.SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_FINISH:
      return {...state, activateSuccess: false, loading: false}

    // SINGLE DEACTIVATE
    case actionTypes.SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_REQUEST:
      return {...state, loading: true}

    case actionTypes.SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_SUCCESS:
      return {...state, deactivateSuccess: true, loading: false}

    case actionTypes.SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_FINISH:
      return {...state, deactivateSuccess: false, loading: false}

    default:
      return state
  }
}
